module.exports = __webpack_public_path__ + "img/ry_15.d579ffc1.png";